// This app deliberately does NOT use a service worker. See src/service-worker.ts
// for the history: a Workbox-based SW here previously caused a confirmed
// staleness bug (2026-09-04) where already-open tabs (and even hard reloads
// in the same non-incognito profile) kept running old, cached JS/HTML for
// many minutes after a new deploy, because the SW's update lifecycle never
// force-activated a newly-installed worker. This app has no offline/PWA
// requirement, so instead of fixing that lifecycle we removed the service
// worker's ability to serve stale content at all.
//
// unregister() is called (instead of a register() call) from src/index.tsx
// on every load, for every client -- including ones that already have an
// old SW installed from before this fix shipped -- so any lingering
// registration and any Cache Storage entries it created get swept away.
// (src/service-worker.ts is also a self-destructing "kill switch" for the
// case where the OLD active SW is still intercepting fetches and this new
// app JS can't even run yet -- see that file for how it self-heals.)

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      })
      .catch((error) => {
        console.error('Error unregistering service worker(s):', error);
      });
  }

  if ('caches' in window) {
    caches
      .keys()
      .then((cacheNames) => Promise.all(cacheNames.map((name) => caches.delete(name))))
      .catch((error) => {
        console.error('Error clearing caches:', error);
      });
  }
}
